import {firebase} from '../../utilities'
import { Timestamp } from 'firebase/firestore'


function convertDates(project) {
  project.created = new Timestamp(project.created?._seconds, project.created?._nanoseconds)
  project.updated = new Timestamp(project.updated?._seconds, project.updated?._nanoseconds)

  if (project.inspection && project.inspection.date) {
    project.inspection.date = new Timestamp(
      project.inspection.date._seconds,
      project.inspection.date._nanoseconds
    )
  }

  return project
}

export default function convertElastic(res) {
  const projects = res.map((h) => h._source).map(convertDates)

  return projects
}
